(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-notes', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
         html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.style.opacity = 1;
              this.toggleFavorites();
              new RevolutionSwiper(this.querySelector('.swiper'));
              new AddToCart(this);
              if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
                new RevolutionAnimation(this);
              }
            }

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '-200px 0px 200px 0px'}).observe(this);
    }

    toggleFavorites() {
      var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
      var favorites = document.querySelectorAll(".ProductCard--Favorites");
      favorites.forEach(function (item) {
        var state = item.getAttribute("state");
        var myID = item.getAttribute("data-id");

        if (state == "not-active" && items.includes(myID)) {
          item.querySelector(".brokenHearth").style.display = "block";
          item.querySelector(".emptyHearth").style.display = "none";
          item.setAttribute("state", "active");
        } else if (!items.includes(myID)) {
          item.querySelector(".brokenHearth").style.display = "none";
          item.querySelector(".emptyHearth").style.display = "block";
          item.setAttribute("state", "not-active");
        }
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
